import HandleResponses from '@common/utils/handleResponses';
import axios from '../../../axios';
import invoiceStatusList from '../../../constants/invoiceStatus';

const actions = {
  async statusList({ commit }) {
    try {
      const result = await axios('/invoice/status-list');
      if (result && result.data) {
        commit('getStatusList', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    }
  },
  async paginate({ commit }, data) {
    commit('paginationCheck', true);
    try {
      if (data.page === 1) {
        commit('resetInvoices', []);
      }
      const result = await axios('invoice/', { params: data });
      if (result && result.data) {
        commit('setInvoices', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('paginationCheck', false);
    }
  },
  async customFields({ commit }) {
    try {
      const result = await axios('/invoice/custom_fields');
      if (result && result.data) {
        commit('setCustomFields', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    }
  },
  async exportMiro({ commit }, data) {
    commit('loadingCheck', false);
    try {
      await axios({ url: '/invoice/miro',
        method: 'POST',
        data: { data } });
      return 'EXPORT_VIA_EMAIL';
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async exportInvoice({ commit }, { ids, status, date_range }) {
    commit('loadingCheck', false);
    try {
      const result = await axios({ url: '/invoice/export',
        method: 'POST',
        responseType: 'blob',
        data: { ids, status, date_range } });
      if (result.size) {
        const extractStatus = invoiceStatusList.find(invoice => invoice.id === status);
        const statusName = extractStatus && extractStatus.name;
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `Invoice-${statusName}-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return (result.size === 0) ? 'EXPORT_VIA_EMAIL' : false;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async customFieldsUpdate({ commit }, { id, fields }) {
    commit('loadingCheck', true);
    try {
      const result = await axios.put(`/invoice/${id}/custom_fields`, { data: fields });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('loadingCheck', false);
    }
  },
  async reasonFields({ commit }) {
    try {
      const result = await axios('/invoice/return_reason_fields');
      if (result && result.data) {
        commit('setReturnFields', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    }
  },
  async reapprove({ commit }, data) {
    try {
      commit('progressCheck', true);
      const result = await axios.put('/invoice/reapprove', { data: { ids: data.ids } });
      return HandleResponses.Status(result);
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('progressCheck', false);
    }
  },
  async updateStatus({ commit }, data) {
    try {
      commit('progressCheck', true);
      const result = await axios.put(`/invoice/${data.action}`, { data: { ids: data.ids, type: data.type } });
      return HandleResponses.Status(result);
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('progressCheck', false);
    }
  },
  async genrateVoucher({ commit }, data) {
    try {
      commit('progressCheck', true);
      const result = await axios.post('/invoice/generate_voucher', { data: { ids: data.ids, voucher_number: data.voucher_number } });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('progressCheck', false);
    }
  },
  async find({ commit }, params) {
    try {
      commit('loadingCheck', true);
      const url = (params.type) ? params.type : '';
      const result = await axios(`/invoice/${params.invoiceId}/${url}`);
      if (result.data.length) {
        commit('setVoucher', result.data);
      } else {
        commit('setInvoice', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('loadingCheck', false);
    }
  },
  async search({ commit }, data) {
    commit('progressCheck', true);
    try {
      if (data.page === 1) {
        commit('resetInvoices', []);
      }
      const result = await axios('invoice/search/', { params: data });
      if (result && result.data) {
        commit('setInvoices', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('progressCheck', false);
    }
  },
  async transporters({ commit }) {
    try {
      const result = await axios.get('/invoice/transporter');
      if (result && result.data) {
        commit('setTransporters', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async save({ commit }, params) {
    try {
      commit('progressCheck', true);
      const result = await axios.put(`/invoice/${params.id}`, { data: params.data.order_payments });
      if (result && result.data) {
        commit('setInvoice', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('progressCheck', false);
    }
  },
  async approve({ commit }, params) {
    try {
      commit('progressCheck', true);
      const result = await axios.put(`/invoice/${params.id}/accept`, { data: {
        type: params.type,
        amount: params.amount,
        reference_number: params.reference_number,
      } });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('progressCheck', false);
    }
  },
  async verify({ commit }, params) {
    try {
      commit('progressCheck', true);
      const result = await axios.put(`/invoice/${params.id}/verify`);
      if (result && result.data) {
        commit('setInvoice', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('progressCheck', false);
    }
  },
  async reject({ commit }, params) {
    commit('progressCheck', true);
    try {
      const result = await axios.put(`/invoice/${params.id}/reject`, { data: { return_reason: params.reason } });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('progressCheck', false);
    }
  },
  async bulkUpload({ commit }, data) {
    commit('setBulkLoading', true);
    try {
      const result = await axios.put('/invoice/paymentupload', data, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return HandleResponses.Status(result);
    } catch (error) {
      commit('setBulkLoading', false);
      return HandleResponses.Status(error);
    }
  },

  async uploadStatus({ commit }) {
    try {
      const result = await axios.get('/invoice/upload_status');
      if (result.data.code !== 'PROGRESS') {
        commit('setBulkLoading', false);
      }
      return result.data;
    } catch (error) {
      commit('setBulkLoading', false);
      return HandleResponses.Status(error);
    }
  },
  async rejectDownload({ commit }) {
    try {
      commit('setBulkLoading', true);
      const result = await axios({ url: '/invoice/rejected/download',
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `RejectionList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('setBulkLoading', false);
    }
  },
  async showUpdatedDates({ commit }, { referenceId }) {
    try {
      commit('voucherUpdatedDates', []);
      const result = await axios.get(`/invoice/${referenceId}/payment_date`);
      if (result && result.data) {
        commit('voucherUpdatedDates', result.data);
      }
      return result.data;
    } catch (error) {
      commit('setBulkLoading', false);
      return HandleResponses.Status(error);
    }
  },

  async addComment({ commit }, { data }) {
    try {
      commit('commentLoading', true);
      commit('setComments', []);
      const result = await axios.post('/conversation', { data });
      if (result && result.data) {
        commit('setComments', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('commentLoading', false);
    }
  },

  async comments({ commit }, { data }) {
    try {
      commit('setComments', []);
      const result = await axios(`conversation/${data.id}/`, { params: { section: data.section } });
      if (result && result.data) {
        commit('setComments', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

};
export default actions;
